import Inflector from 'ember-inflector';
export function initialize( /* application */
) {
  const inflector = Inflector.inflector;

  // Without this: e.g (channel-meta => channel-metum)
  inflector.irregular('meta', 'metas');
}
export default {
  initialize
};